module.exports = __webpack_public_path__ + "assets/img/海量金融数据.d22202a4.jpg";